import { render } from "./button-group.vue?vue&type=template&id=0a2d88e1&ts=true"
import script from "./button-group.vue?vue&type=script&lang=ts"
export * from "./button-group.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\学习记录\\vue3组件封装\\w-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__